class ProductCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.timerInterval = null;
    this.daysEl = null;
    this.hoursEl = null;
    this.minutesEl = null;
    this.secondsEl = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  parseDate(dateString) {
    if (!dateString) return null;
    const str = String(dateString).trim();

    // Check if unix timestamp (seconds or ms)
    if (/^\d{10,13}$/.test(str)) {
      const ts = parseInt(str, 10);
      return new Date(ts < 1e11 ? ts * 1000 : ts);
    }

    // Check YYYY-MM-DD date-only format (run till end of that day)
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      const d = new Date(`${str}T23:59:59`);
      if (!isNaN(d.getTime())) return d;
    }

    // Check MM-DD-YYYY or DD-MM-YYYY format
    if (/^\d{2}-\d{2}-\d{4}$/.test(str)) {
      const parts = str.split('-');
      const d = new Date(`${parts[2]}-${parts[0]}-${parts[1]}T23:59:59`);
      if (!isNaN(d.getTime())) return d;
    }

    const parsed = new Date(str);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  init() {
    this.daysEl = this.querySelector('.countdown-days');
    this.hoursEl = this.querySelector('.countdown-hours');
    this.minutesEl = this.querySelector('.countdown-minutes');
    this.secondsEl = this.querySelector('.countdown-seconds');

    // Fallback if specific classes are not present
    if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
      const pElements = this.querySelectorAll('.countdown__item p');
      if (pElements.length >= 4) {
        this.daysEl = pElements[0];
        this.hoursEl = pElements[1];
        this.minutesEl = pElements[2];
        this.secondsEl = pElements[3];
      }
    }

    this.calculate();
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = setInterval(this.calculate.bind(this), 1000);
  }

  calculate() {
    const rawDate = this.getAttribute('data-expires') || this.getAttribute('data-endtime');
    const targetDate = this.parseDate(rawDate);

    if (!targetDate) {
      return;
    }

    const now = new Date();
    const timeDifference = targetDate.getTime() - now.getTime();
    const isCompact = this.getAttribute('data-compact') === 'true';

    const setVal = (el, val, unit) => {
      if (!el) return;
      if (el.tagName === 'SPAN') {
        el.textContent = val;
      } else if (isCompact) {
        el.textContent = `${val}${unit}`;
      } else {
        el.textContent = val;
      }
    };

    if (timeDifference <= 0) {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
      setVal(this.daysEl, '00', 'd');
      setVal(this.hoursEl, '00', 'h');
      setVal(this.minutesEl, '00', 'm');
      setVal(this.secondsEl, '00', 's');

      const wrapper = this.closest('.winix-cart-btn-wrapper') || this.closest('.product-countdown-wrapper') || this.closest('.product-countdown');
      const isDesignMode = document.querySelector('.shopify-design-mode') || (window.Shopify && window.Shopify.designMode);
      if (wrapper && !isDesignMode) {
        wrapper.style.display = 'none';
      }
      return;
    }

    const secondsInADay = 1000 * 60 * 60 * 24;
    const secondsInAHour = 1000 * 60 * 60;
    const secondsInAMinute = 1000 * 60;

    const days = Math.floor(timeDifference / secondsInADay);
    const hours = Math.floor((timeDifference % secondsInADay) / secondsInAHour);
    const mins = Math.floor((timeDifference % secondsInAHour) / secondsInAMinute);
    const secs = Math.floor((timeDifference % secondsInAMinute) / 1000);

    const pad = (n) => String(n).padStart(2, '0');

    setVal(this.daysEl, pad(days), 'd');
    setVal(this.hoursEl, pad(hours), 'h');
    setVal(this.minutesEl, pad(mins), 'm');
    setVal(this.secondsEl, pad(secs), 's');
  }
}

if (!customElements.get('product-countdown-timer')) {
  customElements.define('product-countdown-timer', ProductCountdownTimer);
}
